"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upcomingHearingContract = exports.CreateUpcomingHearingRequest = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const upcoming_hearing_schemas_1 = require("./resources/upcoming-hearing.schemas");
const refine_1 = require("./util/refine");
const c = (0, core_1.initContract)();
const CreateUpcomingHearingRequestSchema = upcoming_hearing_schemas_1.UpcomingHearingSchema.omit({
    id: true,
    caseId: true,
});
exports.CreateUpcomingHearingRequest = CreateUpcomingHearingRequestSchema.refine((refine_1.is));
const path = '/upcoming-hearing';
exports.upcomingHearingContract = c.router({
    createUpcomingHearing: {
        method: 'POST',
        path,
        headers: resources_1.ApiAuthHeadersSchema,
        responses: {
            [201]: upcoming_hearing_schemas_1.UpcomingHearing,
            [409]: resources_1.UpcomingHearingConflictResponse.or(resources_1.BadLocationIdResponseSchema),
        },
        body: exports.CreateUpcomingHearingRequest,
        summary: 'Create an upcoming hearing',
    },
    deleteUpcomingHearing: {
        method: 'DELETE',
        path,
        headers: resources_1.ApiAuthHeadersSchema,
        responses: {
            [204]: zod_1.default.undefined(),
        },
        body: null,
        query: zod_1.default.object({ id: zod_1.default.string().uuid() }),
        summary: 'Delete an upcoming hearing by its ID',
    },
    getUpcomingHearing: {
        method: 'GET',
        path,
        headers: resources_1.ApiAuthHeadersSchema,
        responses: {
            [200]: upcoming_hearing_schemas_1.UpcomingHearing,
            [404]: null,
        },
        query: zod_1.default.object({ id: zod_1.default.string().uuid() }),
        summary: 'Get an upcoming hearing by its ID',
    },
    putUpcomingHearing: {
        method: 'PUT',
        path,
        headers: resources_1.ApiAuthHeadersSchema,
        responses: {
            [200]: upcoming_hearing_schemas_1.UpcomingHearing,
            [404]: null,
            [409]: resources_1.UpcomingHearingConflictResponse.or(resources_1.BadLocationIdResponseSchema),
        },
        body: upcoming_hearing_schemas_1.UpcomingHearingUpdate,
        summary: 'Put an upcoming hearing by its ID',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
    commonResponses: (0, resources_1.errorResponses)(),
});
